import { Component, Input } from '@angular/core';
import { ASSESSMENT_STATUS } from '@ids-constants';
import { BaseComponent } from '@ids-components';
import { CardComponent, LoadingOverlayComponent } from '@microsec/components';
import { CommonModule } from '@angular/common';
import { MomentPipe } from '@ids-pipes';
@Component({
  selector: 'app-assessment-overview',
  templateUrl: './assessment-overview.component.html',
  styleUrls: ['./assessment-overview.component.scss'],
  imports: [CommonModule, LoadingOverlayComponent, CardComponent, MomentPipe],
})
export class AssessmentOverviewComponent extends BaseComponent {
  isLoading = false;

  _assessment: any = {};

  get assessment() {
    return this._assessment;
  }

  @Input() set assessment(value: any) {
    this._assessment = {
      ...(value || {}),
      descriptionPreview: this.util.parseMarkdown(value?.description || ''),
      displayProgress: Math.floor((value.progress || 0) * 100),
    };
  }

  ASSESSMENT_STATUS = ASSESSMENT_STATUS;
}
